import $http from '@/api';

export default {
  async fetchActivityFeed() {
    const { feed } = await $http.get('/api/staff/activity');
    return feed;
  },
  async postActivity(activity) {
    return $http.post('/api/staff/activity', { data: activity });
  },
};
